import React, { useEffect, useRef } from 'react';
import { connect, history } from 'umi';

import { goBack } from '@/utils/utils';
import backIcon from '@/assets/images/ic_back_export.png';
import styles from './index.less';
import { Clickable } from '@/components';

const MemberHeader = props => {
  const { title, titleColor, titleFontFamily, goBack: propsGoback, hideGoBack = false } = props;

  const marqueeContainerRef = useRef(null);
  const marqueeContentRef = useRef(null);

  const rawQuery = history.location.query || {};
  const needGoBack = !!rawQuery.needGoBack;
  const needGoBackByApp = !!rawQuery.needGoBackByApp;

  const handleGoBack = () => {
    if (needGoBackByApp) {
      goBack();
    } else if (needGoBack) {
      history.goBack();
    } else if (typeof propsGoback === 'function') {
      propsGoback();
    } else {
      history.goBack();
    }
  };

  useEffect(() => {
    const marqueeContainer = marqueeContainerRef.current;
    const marqueeContent = marqueeContentRef.current;

    if (!(marqueeContent && marqueeContainer)) {
      return;
    }

    if (marqueeContent.offsetWidth > marqueeContainer.offsetWidth) {
      marqueeContent.classList.add(styles.scroll);
    } else {
      marqueeContent.classList.remove(styles.scroll);
    }
  }, []);

  return (
    <header
      className={styles.memHeader}
      style={{
        paddingLeft: hideGoBack ? '0.16rem' : 0,
      }}
    >
      <Clickable
        className={`${styles.imgBox} ${hideGoBack ? styles.hideGoBack : ''}`}
        onClick={handleGoBack}
      >
        <img alt="" src={backIcon} />
      </Clickable>
      <h3 title={title} style={{ color: titleColor, fontFamily: titleFontFamily }}>
        {title}
      </h3>
      <div />
    </header>
  );
};

export default connect(({ index }) => ({
  activityDetail: index.activityDetail,
  projectName: index.projectName,
}))(MemberHeader);
